


































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import AdvancedCalendar from "@/components/Calendar/AdvancedCalendar.vue";

@Component({
  name: "CalendarDemo",
  components: {
    AdvancedCalendar,
  },
})
export default class CalendarDemo extends Vue {
  googleApiKey = "";
  googleCalendarId = "";
  appliedGoogleApiKey = "";
  appliedGoogleCalendarId = "";
  enableGoogleSync = false;

  snackbar = false;
  snackbarText = "";
  snackbarColor = "success";

  events = [
    {
      id: "1",
      title: "Reunión de Equipo",
      start: new Date(2025, 11, 15, 10, 0),
      end: new Date(2025, 11, 15, 11, 0),
      description: "Reunión semanal del equipo de desarrollo",
      color: "#519DE1",
      category: "Trabajo",
      allDay: false,
    },
    {
      id: "2",
      title: "Presentación Cliente",
      start: new Date(2025, 11, 18, 14, 0),
      end: new Date(2025, 11, 18, 16, 0),
      description: "Presentación del proyecto al cliente",
      color: "#FF5722",
      category: "Reunión",
      allDay: false,
    },
    {
      id: "3",
      title: "Cumpleaños Juan",
      start: new Date(2025, 11, 20),
      description: "Felicitar a Juan por su cumpleaños",
      color: "#FFAB40",
      category: "Personal",
      allDay: true,
    },
    {
      id: "4",
      title: "Sprint Planning",
      start: new Date(2025, 11, 22, 9, 0),
      end: new Date(2025, 11, 22, 12, 0),
      description: "Planificación del nuevo sprint",
      color: "#009688",
      category: "Trabajo",
      allDay: false,
    },
  ];

  applyGoogleConfig() {
    this.appliedGoogleApiKey = this.googleApiKey;
    this.appliedGoogleCalendarId = this.googleCalendarId;
    this.enableGoogleSync = true;
    this.showSnackbar("Configuración de Google Calendar aplicada", "success");
  }

  handleEventAdd(event: any) {
    this.events.push(event);
    this.showSnackbar("Evento creado exitosamente", "success");
  }

  handleEventUpdate(event: any) {
    const index = this.events.findIndex((e) => e.id === event.id);
    if (index !== -1) {
      this.events.splice(index, 1, event);
    }
    this.showSnackbar("Evento actualizado", "success");
  }

  handleEventDelete(event: any) {
    const index = this.events.findIndex((e) => e.id === event.id);
    if (index !== -1) {
      this.events.splice(index, 1);
    }
    this.showSnackbar("Evento eliminado", "warning");
  }

  handleEventClick(event: any) {
    console.log("Event clicked:", event);
  }

  handleGoogleSync() {
    this.showSnackbar("Sincronizando con Google Calendar...", "info");
  }

  showSnackbar(text: string, color: string) {
    this.snackbarText = text;
    this.snackbarColor = color;
    this.snackbar = true;
  }
}
